import { selectors as authSelectors } from '@hixme/auth-ui'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { ActivityReasonCategory } from 'types/activity'
import { FormData, openActivityLogPopup } from '../activityLogPopupSlice'

export interface ActivityLogPopupOptions {
  contentText?: string
  onCancel?: () => void
  onSubmit?: (formData: FormData) => void
  required: boolean
  reason?: string
  reasonCategory?: ActivityReasonCategory
  zendeskTicket?: string
}

export const useActivityLogPopup = () => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state, shallowEqual)
  const userRole = useMemo(() => authSelectors.getRole(state), [state])
  const { flags } = useFeatureFlags()

  const showPopup = (
    options: ActivityLogPopupOptions = { required: false }
  ) => {
    dispatch(openActivityLogPopup(options))
  }

  const showConfirmationPopup = ({
    contentText,
    onSubmit,
    onCancel,
    required,
    isShowActivityLogPopup = true,
  }: {
    contentText: string
    onSubmit: (formData: FormData) => void
    onCancel?: () => void
    required: boolean
    isShowActivityLogPopup?: boolean
  }) => {
    if (
      userRole === ROLE_PLATFORM_HIXME_ADMIN &&
      flags['admin.activity-log-reason-popup-enabled'] &&
      isShowActivityLogPopup
    ) {
      showPopup({
        contentText,
        onSubmit,
        onCancel,
        required,
      })
    } else {
      // bypass activity log for non-admin users
      onSubmit?.({
        reason: '',
        reasonCategory: ActivityReasonCategory.OTHER,
        zendeskTicket: '',
      })
    }
  }

  return {
    showPopup,
    showConfirmationPopup,
  }
}
